import { useNavigate } from 'react-router-dom'
import { GoDotFill } from 'react-icons/go'

const rotatingTips = [
    {
        emoji: '🔢',
        short: 'Zaokrúhľuj vklady — nikdy nepodávaj za 67,92 €.',
        sub: 'Používaj 5 €, 10 €, 50 €. Presné sumy sú pre stávkovky podozrivé.'
    },
    {
        emoji: '📊',
        short: 'Zapíš každú stávku do BetTrackera.',
        sub: 'Budeš presne vedieť koľko zarábaš, kde a z čoho.'
    },
    {
        emoji: '⭐',
        short: 'Stávkuj na žlté zápasy — tie sú najbezpečnejšie.',
        sub: 'Veľa ľudí stávkuje na populárne zápasy, tvoja stávka sa stratí v dave.'
    },
    {
        emoji: '🆕',
        short: 'Na novom účte začni normálnymi stávkami, nie surebetmi.',
        sub: 'Prvé tikety sú pre stávkovku najdôležitejšie. Daj 5-10 bežných stávok za 5–10 €.'
    },
    {
        emoji: '📱',
        short: 'Sleduj @arbitrage.sk na Instagrame.',
        sub: 'Novinky, tipy a upozornenia na nové funkcie priamo v feed-e.'
    },
    {
        emoji: '🎲',
        short: 'Občas hoď live alebo kombinovanú stávku.',
        sub: 'Bežní hráči kombinujú typy stávok. Pomáha to vyzerať prirodzene.'
    },
    {
        emoji: '💸',
        short: 'Vklady rob cez internetbanking, nie kartou.',
        sub: 'Platby kartou majú poplatok za hazard 5–7 €. IB je bez poplatku.'
    },
    {
        emoji: '⏱️',
        short: 'Nikdy nepodávaj tiket pár sekúnd pred výkopom.',
        sub: 'Nestihneš dopodávať druhú stranu. Ideálny čas je aspoň 5 minút pred zápasom.'
    },
    {
        emoji: '🔔',
        short: 'Zapni Telegram notifikácie — nestráš žiadnu arbitráž.',
        sub: 'Nastav si filter podľa ROI a dostaneš správu priamo na telefón.'
    },
    {
        emoji: '🏦',
        short: 'Nevyberaj peniaze príliš často.',
        sub: 'Časté výbery pôsobia podozrivo. Nechaj zostatok chvíľu rásť.'
    },
    {
        emoji: '📉',
        short: 'Vyhýbaj sa arbitrážam s vyšším ROI',
        sub: 'Vysoké ROI môžu byť pasce od stávkoviek. Menší zisk, väčší objem je lepšia stratégia.'
    },
    {
        emoji: '🔗',
        short: 'Najprv podaj v kancelárii s dlhším časom na stornovanie.',
        sub: 'Ak nestihneš druhú stranu, vieš prvú stornovať zadarmo.'
    },
    {
        emoji: '🔍',
        short: 'Vždy skontroluj tímy aj čas zápasu pred podaním.',
        sub: 'Uisti sa že v oboch stávkovkách sedí domáci tím, hosť aj presný čas začiatku.'
    },
    {
        emoji: '📤',
        short: 'Výbery vždy na vlastný IBAN.',
        sub: 'Stávkovky si môžu pýtať potvrdenie že účet je tvoj. Peniaze prídu nasledujúci pracovný deň.'
    },
    {
        emoji: '🤝',
        short: 'Nike, Fortuna, Tipsport, Doxxbet, Synottip a Tipos sú licencované spoločnosti.',
        sub: 'Aj keď ťa obmedzia, vždy môžeš vybrať celý zostatok.'
    },
    {
        emoji: '🟡',
        short: 'Klikni na logo stávkovky — hodí ťa priamo na zápas.',
        sub: 'Nemusíš nič hľadať v aplikácii. Ušetríš čas a znížiš riziko že arbitráž zmizne.'
    },
    {
        emoji: '🏆',
        short: 'Prematch arbitráže sú najlepšie v piatok a sobotu.',
        sub: 'Vtedy prebieha najviac futbalových líg a je najväčší výber arbitráží.'
    },
    {
        emoji: '👁️',
        short: 'Občas skontroluj cashout oboch stávok.',
        sub: 'Niekedy je profit pri predčasnom vyplatení vyšší než keď necháš zápas dohrať.'
    },
    {
        emoji: '🎰',
        short: 'Sem-tam hoď pár eur do kasína alebo na live stávku.',
        sub: 'Účet vyzerá prirodzenejšie ak občas hráš aj inak než len surebety.'
    },
    {
        emoji: '📵',
        short: 'Nepoužívaj rovnakú IP pre viacero účtov rôznych ľudí.',
        sub: 'Stávkovky sledujú IP adresy. Ak stávkuješ za kamaráta, použi iné pripojenie.'
    },
]

const getDailyTip = () => {
    const minute = Math.floor(Date.now() / 60000)
    return rotatingTips[minute % rotatingTips.length]
}

const NewUserBanner = ({ invoices }) => {
    const navigate = useNavigate()
    const hasNoInvoices = !invoices || invoices.length === 0
    const hasPaid = invoices && invoices.length >= 1

    if (!hasNoInvoices && !hasPaid) return null

    if (hasNoInvoices) {
        return (
            <>
                {/* SMALL SCREEN */}
                <div
                    className="mx-sm-2 mt-2 mt-2 p-3 p-sm-4 rounded-4 d-block d-sm-none"
                    style={{ backgroundColor: '#222222', cursor: 'pointer', position: 'relative' }}
                    onClick={() => navigate('/getting-started')}
                >
                    <span style={{ position: 'absolute', top: 0, right: 0, width: '24px', height: '24px' }}
                        className='d-flex justify-content-center align-items-center'>
                        <GoDotFill color='#FFD700' />
                    </span>
                    <div className="row" style={{ minHeight: '50px' }}>
                        <div className="col-3 p-0 d-flex align-items-center justify-content-center fs-1 font1">👋</div>
                        <div className="col-9 d-flex flex-column justify-content-center">
                            <div className="row ps-1 lh-sm">
                                <div className="col text-truncate font1 text-white">
                                    Si tu nový? Prečítaj si toto pred prvou stávkou
                                </div>
                            </div>
                            <div className="row ps-1 lh-sm">
                                <div className="col text-truncate font1 text-secondary" style={{ fontSize: '0.85rem' }}>
                                    Účty · Vklady · BetTracker · Notifikácie · Návod

                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

                {/* BIG SCREEN */}
                <div
                    className="font2 row mx-1 mb-0 mt-2 rounded rounded-4 align-middle d-none d-sm-flex"
                    style={{ background: '#222222', minHeight: '100px', cursor: 'pointer', position: 'relative' }}
                    onClick={() => navigate('/getting-started')}
                >
                    <span style={{ position: 'absolute', top: '4px', right: '8px' }}>
                        <GoDotFill color='#FFD700' />
                    </span>
                    <div className='d-flex justify-content-center align-items-center' style={{ width: '80px', fontSize: '1.8rem' }}>
                        👋
                    </div>
                    <div className='col p-0'>
                        <div className='h-100 d-flex flex-column justify-content-center'>
                            <div className='container-fluid'>
                                <div className='row'>
                                    <div className='col d-flex align-items-end' style={{ overflow: 'hidden' }}>
                                        <span className='lh-base d-inline-block text-truncate text-white'
                                            style={{ width: '100%', fontSize: '1rem', fontWeight: 500 }}>
                                            Si tu nový? Prečítaj si toto pred prvou stávkou
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='container-fluid'>
                                <div className='row'>
                                    <div className='col d-flex align-items-start' style={{ overflow: 'hidden' }}>
                                        <span className='lh-base d-inline-block text-truncate text-secondary text-uppercase'
                                            style={{ width: '100%', fontSize: '0.85rem' }}>
                                            Účty · Vklady · BetTracker · Telegram notifikácie · Celý návod
                                        </span>
                                    </div>
                                    <div className='col-auto p-0 pe-3 d-flex align-items-start text-secondary' style={{ fontSize: '0.85rem' }}>
                                        Klikni pre detaily →
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    // Platiaci user — rotujuci tip
    const tip = getDailyTip()

    return (
        <>
            {/* SMALL SCREEN */}
            <div
                className="mx-sm-2 mt-2 mt-2 p-3 p-sm-4 rounded-4 d-block d-sm-none"
                style={{ backgroundColor: '#222222', position: 'relative' }}
            >
                <div className="row" style={{ minHeight: '50px' }}>
                    <div className="col-2 p-0 d-flex align-items-center justify-content-center fs-1 font1">
                        {tip.emoji}
                    </div>
                    <div className="col-9 d-flex flex-column justify-content-center">
                        <div className="row ps-1 lh-sm">
                            <div className="col font1 text-white" style={{ fontSize: '0.9rem' }}>
                                {tip.short}
                            </div>
                        </div>
                        <div className="row ps-1 mt-1">
                            <div className="col font1 text-secondary" style={{ fontSize: '0.8rem', lineHeight: 1.5 }}>
                                {tip.sub}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* BIG SCREEN */}
            <div
                className="font2 row mx-1 mb-0 mt-2 rounded rounded-4 align-middle d-none d-sm-flex"
                style={{ background: '#222222', minHeight: '100px', position: 'relative' }}
            >
                <div className='d-flex justify-content-center align-items-center' style={{ width: '80px', fontSize: '1.8rem' }}>
                    {tip.emoji}
                </div>
                <div className='col p-0'>
                    <div className='h-100 d-flex flex-column justify-content-center'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col d-flex align-items-end' style={{ overflow: 'hidden' }}>
                                    <span className='lh-base d-inline-block text-truncate text-white'
                                        style={{ width: '100%', fontSize: '1rem', fontWeight: 500 }}>
                                        {tip.short}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col d-flex align-items-start' style={{ overflow: 'hidden' }}>
                                    <span className='lh-base d-inline-block text-secondary'
                                        style={{ width: '100%', fontSize: '0.85rem' }}>
                                        {tip.sub}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewUserBanner